import { render, staticRenderFns } from "./LocalDiscoveryAddOrEdit.vue?vue&type=template&id=8fa98628&scoped=true"
import script from "./LocalDiscoveryAddOrEdit.vue?vue&type=script&lang=js"
export * from "./LocalDiscoveryAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./LocalDiscoveryAddOrEdit.vue?vue&type=style&index=0&id=8fa98628&prod&scoped=true&lang=less"
import style1 from "./LocalDiscoveryAddOrEdit.vue?vue&type=style&index=1&id=8fa98628&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa98628",
  null
  
)

export default component.exports